import React from 'react'

export default ({ ...props }) => (
  <svg {...props} width='18' height='19' viewBox='0 0 18 19' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g clipPath='url(#clip0)'>
      <path
        d='M2.25005 18.4392C2.00165 18.4392 1.80005 18.2376 1.80005 17.9892V10.7892C1.80005 10.5408 2.00165 10.3392 2.25005 10.3392C2.49845 10.3392 2.70005 10.5408 2.70005 10.7892V17.9892C2.70005 18.2376 2.49845 18.4392 2.25005 18.4392Z'
        fill='#0D0D0D'
      />
      <path
        d='M2.25005 5.83921C2.00165 5.83921 1.80005 5.63761 1.80005 5.38921V0.889209C1.80005 0.640809 2.00165 0.439209 2.25005 0.439209C2.49845 0.439209 2.70005 0.640809 2.70005 0.889209V5.38921C2.70005 5.63761 2.49845 5.83921 2.25005 5.83921Z'
        fill='#0D0D0D'
      />
      <path
        d='M3.15 9.43926H1.35C0.6057 9.43926 0 8.83356 0 8.08926C0 7.34496 0.6057 6.73926 1.35 6.73926H3.15C3.8943 6.73926 4.5 7.34496 4.5 8.08926C4.5 8.83356 3.8943 9.43926 3.15 9.43926ZM1.35 7.63926C1.1016 7.63926 0.9 7.84086 0.9 8.08926C0.9 8.33766 1.1016 8.53926 1.35 8.53926H3.15C3.3984 8.53926 3.6 8.33766 3.6 8.08926C3.6 7.84086 3.3984 7.63926 3.15 7.63926H1.35Z'
        fill='#0D0D0D'
      />
      <path
        d='M8.5501 18.4392C8.3017 18.4392 8.1001 18.2376 8.1001 17.9892V14.3892C8.1001 14.1408 8.3017 13.9392 8.5501 13.9392C8.7985 13.9392 9.0001 14.1408 9.0001 14.3892V17.9892C9.0001 18.2376 8.7985 18.4392 8.5501 18.4392Z'
        fill='#0D0D0D'
      />
      <path
        d='M8.5501 9.43921C8.3017 9.43921 8.1001 9.23761 8.1001 8.98921V0.889209C8.1001 0.640809 8.3017 0.439209 8.5501 0.439209C8.7985 0.439209 9.0001 0.640809 9.0001 0.889209V8.98921C9.0001 9.23761 8.7985 9.43921 8.5501 9.43921Z'
        fill='#0D0D0D'
      />
      <path
        d='M9.45005 13.0392H7.65005C6.90575 13.0392 6.30005 12.4335 6.30005 11.6892C6.30005 10.9449 6.90575 10.3392 7.65005 10.3392H9.45005C10.1943 10.3392 10.8 10.9449 10.8 11.6892C10.8 12.4335 10.1943 13.0392 9.45005 13.0392ZM7.65005 11.2392C7.40165 11.2392 7.20005 11.4408 7.20005 11.6892C7.20005 11.9376 7.40165 12.1392 7.65005 12.1392H9.45005C9.69845 12.1392 9.90005 11.9376 9.90005 11.6892C9.90005 11.4408 9.69845 11.2392 9.45005 11.2392H7.65005Z'
        fill='#0D0D0D'
      />
      <path
        d='M14.8499 18.4392C14.6015 18.4392 14.3999 18.2376 14.3999 17.9892V8.98918C14.3999 8.74078 14.6015 8.53918 14.8499 8.53918C15.0983 8.53918 15.2999 8.74078 15.2999 8.98918V17.9892C15.2999 18.2376 15.0983 18.4392 14.8499 18.4392Z'
        fill='#0D0D0D'
      />
      <path
        d='M14.8499 4.03921C14.6015 4.03921 14.3999 3.83761 14.3999 3.58921V0.889209C14.3999 0.640809 14.6015 0.439209 14.8499 0.439209C15.0983 0.439209 15.2999 0.640809 15.2999 0.889209V3.58921C15.2999 3.83761 15.0983 4.03921 14.8499 4.03921Z'
        fill='#0D0D0D'
      />
      <path
        d='M15.7501 7.63921H13.9501C13.2058 7.63921 12.6001 7.03351 12.6001 6.28921C12.6001 5.54491 13.2058 4.93921 13.9501 4.93921H15.7501C16.4944 4.93921 17.1001 5.54491 17.1001 6.28921C17.1001 7.03351 16.4944 7.63921 15.7501 7.63921ZM13.9501 5.83921C13.7017 5.83921 13.5001 6.04081 13.5001 6.28921C13.5001 6.53761 13.7017 6.73921 13.9501 6.73921H15.7501C15.9985 6.73921 16.2001 6.53761 16.2001 6.28921C16.2001 6.04081 15.9985 5.83921 15.7501 5.83921H13.9501Z'
        fill='#0D0D0D'
      />
    </g>
    <defs>
      <clipPath id='clip0'>
        <rect width='18' height='18' fill='white' transform='translate(0 0.439209)' />
      </clipPath>
    </defs>
  </svg>
)
